/**
 * @file fieldLimits.js
 * @brief Defines frontend field length limits and helper utilities for enforcing them.
 */
export const FIELD_LIMITS = {
    listingTitle: 200,
    listingDescription: 5000,
    messageContent: 2000,
    categoryName: 100,
    categorySlug: 50,
    locationName: 100,
};

/**
 * Trim a value to the configured maximum length while preserving empty inputs.
 * @param {string} value Input value to truncate.
 * @param {number} maxLength Maximum number of characters allowed.
 * @returns {string} Truncated string value.
 */
export function clampToMaxLength(value, maxLength) {
    return (value || "").slice(0, maxLength);
}

/**
 * Remove HTML tags from a rich-text value before validating or counting text.
 * @param {string} value Rich-text HTML content.
 * @returns {string} Plain text content with tags removed.
 */
export function stripHtmlTags(value) {
    return (value || "").replace(/<[^>]*>/g, "");
}